import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 1.5H22V5.96482C22 6.63352 21.6658 7.25799 21.1094 7.62892L15 11.7019V22.5L9 18V11.7019L2.8906 7.62892C2.3342 7.25798 2 6.63352 2 5.96482V1.5Z",
		fill: "#395566"
	})
});
export default SvgFill;
